/**
 * src/pages/Configuracion.jsx
 * Configuración de la cuenta del usuario: cambio de contraseña.
 * Se autentica por el Bearer JWT del panel (api/client inyecta el header).
 */
import { useState } from 'react'
import { Header } from '../components/layout/Header'
import { Card } from '../components/ui/Card'
import { Button } from '../components/ui/Button'
import { useAuthStore } from '../store/authStore'
import { cambiarPassword } from '../api/billing'

const inputStyle = {
  width: '100%', background: 'var(--color-surface-2)',
  border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)',
  padding: '10px 14px', fontSize: 'var(--text-md)', fontFamily: 'var(--font-ui)',
  color: 'var(--color-text)', outline: 'none', boxSizing: 'border-box',
}
const labelStyle = {
  display: 'block', fontSize: 'var(--text-xs)', fontWeight: 500, color: 'var(--color-text-2)',
  marginBottom: '5px', fontFamily: 'var(--font-mono)', letterSpacing: '0.05em',
}

export default function Configuracion() {
  const user = useAuthStore(state => state.user)
  const setToken = useAuthStore(state => state.setToken)
  const [form, setForm] = useState({ actual: '', nueva: '', confirm: '' })
  const [error, setError] = useState('')
  const [ok, setOk] = useState(false)
  const [loading, setLoading] = useState(false)

  function set(field) {
    return e => { setForm(f => ({ ...f, [field]: e.target.value })); setError(''); setOk(false) }
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (form.nueva.length < 8) { setError('La nueva contraseña debe tener al menos 8 caracteres'); return }
    if (form.nueva !== form.confirm) { setError('Las contraseñas nuevas no coinciden'); return }
    if (form.nueva === form.actual) { setError('La nueva contraseña debe ser distinta de la actual'); return }
    setLoading(true); setError(''); setOk(false)
    try {
      const r = await cambiarPassword(form.actual, form.nueva)
      // El backend invalida las demás sesiones y reemite el token de ESTA con el
      // token_version nuevo; sin guardarlo, la siguiente petición daría 401 (A3).
      if (r?.access_token) setToken(r.access_token)
      setOk(true)
      setForm({ actual: '', nueva: '', confirm: '' })
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo cambiar la contraseña.')
    } finally { setLoading(false) }
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Header title="Configuración" subtitle="Cuenta y seguridad" />
      <div style={{ flex: 1, overflow: 'auto', padding: '24px 28px', maxWidth: '600px' }}>
        {user && (
          <Card title="Cuenta" style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
              {[
                ['Nombre', user.nombre],
                ['Correo', user.email],
              ].map(([label, value]) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--color-border)' }}>
                  <span style={{ fontSize: 'var(--text-base)', color: 'var(--color-text-2)' }}>{label}</span>
                  <span style={{ fontSize: 'var(--text-base)', color: 'var(--color-text)' }}>{value}</span>
                </div>
              ))}
            </div>
          </Card>
        )}

        <Card title="Cambiar contraseña">
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div>
              <label style={labelStyle}>CONTRASEÑA ACTUAL</label>
              <input type="password" style={inputStyle} name="current-password" autoComplete="current-password"
                value={form.actual} onChange={set('actual')} placeholder="Tu contraseña actual" disabled={loading}
                onFocus={e => e.target.style.borderColor = 'var(--color-accent)'}
                onBlur={e => e.target.style.borderColor = 'var(--color-border)'} />
            </div>
            <div>
              <label style={labelStyle}>CONTRASEÑA NUEVA</label>
              <input type="password" style={inputStyle} name="new-password" autoComplete="new-password"
                value={form.nueva} onChange={set('nueva')} placeholder="Mínimo 8 caracteres" disabled={loading}
                onFocus={e => e.target.style.borderColor = 'var(--color-accent)'}
                onBlur={e => e.target.style.borderColor = 'var(--color-border)'} />
            </div>
            <div>
              <label style={labelStyle}>REPITE LA NUEVA</label>
              <input type="password" style={inputStyle} name="confirm-password" autoComplete="new-password"
                value={form.confirm} onChange={set('confirm')} placeholder="La misma otra vez" disabled={loading}
                onFocus={e => e.target.style.borderColor = 'var(--color-accent)'}
                onBlur={e => e.target.style.borderColor = 'var(--color-border)'} />
            </div>
            {error && (
              <div style={{ background: 'var(--color-error-soft)', border: '1px solid var(--color-error-line)', borderRadius: 'var(--radius-sm)', padding: '10px 12px', fontSize: 'var(--text-sm)', color: 'var(--color-error)', fontFamily: 'var(--font-mono)' }}>{error}</div>
            )}
            {ok && (
              <div style={{ background: 'var(--color-ok-soft)', border: '1px solid var(--color-ok-line)', borderRadius: 'var(--radius-sm)', padding: '10px 12px', fontSize: 'var(--text-sm)', color: 'var(--color-ok)', fontFamily: 'var(--font-mono)' }}>✓ Contraseña actualizada</div>
            )}
            <div>
              <Button type="submit" loading={loading}>Guardar contraseña</Button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  )
}
